const topicItems = [
  { label: '4K蓝光', count: '1.2万' },
  { label: '悬疑推理', count: '9800' },
  { label: '科幻巨制', count: '8500' },
  { label: '国产剧', count: '2.3万' },
  { label: '韩剧精选', count: '1.5万' },
  { label: '高分经典', count: '6500' },
  { label: '日剧热播', count: '7200' },
  { label: '动漫番剧', count: '1.1万' },
  { label: '动作大片', count: '9300' },
  { label: '喜剧合辑', count: '5600' },
  { label: '纪录片', count: '4800' },
];

export default function Topics() {
  return (
    <section id="topics" className="relative py-16 md:py-20 px-4 md:px-6 bg-background-50">
      <div className="max-w-[960px] mx-auto">
        <div className="text-center mb-10">
          <span className="inline-block px-3 py-1 text-xs font-medium text-accent-400 bg-accent-500/10 rounded-full mb-4">
            热门话题
          </span>
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-50">
            大家都在看的热门话题
          </h2>
          <p className="mt-3 text-sm md:text-base text-foreground-400 max-w-2xl mx-auto">
            发现最受欢迎的影视类型与话题标签
          </p>
        </div>

        <div className="flex flex-wrap justify-center gap-3">
          {topicItems.map((item, idx) => (
            <div
              key={idx}
              className="group flex items-center gap-2 px-4 py-2.5 bg-background-100 hover:bg-background-200 rounded-full border border-background-300/20 hover:border-primary-500/20 transition-all duration-200 cursor-pointer"
            >
              <span className="text-sm text-foreground-200 group-hover:text-primary-400 transition-colors whitespace-nowrap">
                {item.label}
              </span>
              <span className="text-xs text-foreground-500 bg-background-200 group-hover:bg-primary-500/10 px-2 py-0.5 rounded-full whitespace-nowrap transition-colors">
                {item.count}
              </span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}